import { createApp, h } from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store'
import { createPinia } from 'pinia'
import { useUserStore } from '@/stores/userStore'
import { domainMap } from '@/utils/tools'
import doubleTap from '@/directives/doubleTap'

const _siteName = domainMap[window.location.hostname] || 'nexplan'
document.title = _siteName.charAt(0).toUpperCase() + _siteName.slice(1)

import "./assets/css/custom.bootstrap.scss";

// Custom Input Components
import CustomScrollbar from 'custom-vue-scrollbar';
import 'custom-vue-scrollbar/dist/style.css';

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import uploader from 'vue-simple-uploader'
import 'vue-simple-uploader/dist/style.css'

import "simplebar-vue/dist/simplebar.min.css"
import "./assets/css/main.css";
import "./assets/css/mobile.css";

import folderOpenIcon from '@/assets/images/icons/arrow-down.svg'

// Multilingual
import i18n from "./i18n"

const FolderOpenIcon = {
    render() {
      return h('svg', { 
        class: 'vs-drop-icon', 
        innerHTML: `<use href="${folderOpenIcon}#icon"></use>`
      })
    }
  }

vSelect.props.components.default = () => ({
    Deselect: {
      render: () => h('span', '❌'),
    },
    OpenIndicator: {
      render: () => h(FolderOpenIcon),
    }
})

const pinia = createPinia()

let app = createApp(App)
    .use(i18n)
    .use(store)
    .use(pinia)
    .use(uploader)
    .component(CustomScrollbar.name, CustomScrollbar)
    .component('vSelect', vSelect)
    .directive('double-tap', doubleTap)
    
const userStore = useUserStore()

userStore.autoLogin().then(() => {
  app.use(router)
  app.mount('#page-wrap')
})